// extracted by css-extract-rspack-plugin
export default {"Description":"Yph0n","EmptyDescription":"lT8oy"};